import React, { useState, useEffect } from 'react';

import { useContext } from 'components/Members/Onboarding/Context';
import ProgressBar from 'components/Widgets/ProgressBar';
import PrepareReportGeneral from './PrepareReportGeneral';
import PrepareReportReturnToWork from './PrepareReportReturnToWork';

export default function StartTalentAssessment() {
  const { dispatch, state, actions } = useContext();

  const [progress, setProgress] = useState(0);

  const onGoNextClick = () => {
    actions.completeStep(state.steps[state.currentStep].step, () => {
      actions.setNextStep({
        dispatch,
        steps: state.steps,
        isPossibleSkip: false,
        currentStep: state.currentStep,
      });
    });
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setProgress((prev) => {
        const next = prev + 1;
        return next <= 100 ? next : 100;
      });
    }, 100);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (progress >= 100) {
      onGoNextClick();
    }
  }, [progress]);

  return (
    <>
      <div className="onboarding-content my-5">
        <div style={{ maxWidth: '500px', margin: '0 auto' }}>
          <ProgressBar now={progress} />
        </div>
      </div>

      <div className="content onboarding-content">
        {state.workflow === 'RETURN_TO_WORK_ONBOARDING'
          ? <PrepareReportReturnToWork />
          : <PrepareReportGeneral />}
      </div>
    </>
  );
}
